export {
	registerBlockExtension,
	// continue to export misspelled version of api for backwards compatibility
	registerBlockExtension as registerBlockExtention,
	unregisterBlockExtension,
} from './register-block-extension';
export { registerIcons } from './register-icons';
